import type { KnocommerceInfo } from '@/features/Setting/Integrations/providers/types';
import { v1ApiClient } from '@/services/index';

const knocommerceService = {
  async createWorkspaceInfo(
    api_key: string,
    api_secret: string,
    workspaceAlias: string,
  ): Promise<KnocommerceInfo> {
    try {
      const res = await v1ApiClient.post(
        `/workspaces/${workspaceAlias}/knocommerce`,
        {
          client_id: api_key,
          client_secret: api_secret,
        },
      );
      return res.data;
    } catch (e) {
      throw e;
    }
  },

  async getWorkspaceInfo(
    workspaceAlias: string,
  ): Promise<KnocommerceInfo> {
    const res = await v1ApiClient.get(
      `/workspaces/${workspaceAlias}/knocommerce`,
    );
    return res.data;
  },

  async importWorkspaceFeedback(
    workspaceAlias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await v1ApiClient.post(
        `/workspaces/${workspaceAlias}/knocommerce/import`,
        {
          start_date: startDate,
          end_date: endDate,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },

  async deleteWorkspaceInfo(workspaceAlias: string) {
    try {
      await v1ApiClient.delete(`/workspaces/${workspaceAlias}/knocommerce`);
      return true;
    } catch (e) {
      return false;
    }
  },
};

export default knocommerceService;
